<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)"
>
</app-cardholder-details>


<div class="card card-nc" *ngIf="hasEntitlements('CARDHOLDERS_FORMS_ENROLLMENT_FORM_HISTORY')">
  <div class="card-heading ">
    <i class="fa fa-keyboard-o"></i>
    <span class="panelHeaderHeading"> ENROLLMENT FORMS HISTORY </span>
  </div>
  <div
    *ngIf="retrievingForms || pagedMerchantForms.length > 0"
    class="card merchant-forms"
  > <div>&nbsp;</div>
    <div *ngFor="let form of pagedMerchantForms" class="merchant-form">
      <h6 class="merchant-form-header">
        <a class="merchant-form-link" (click)="getEnrollmentForm(form, $event)">
          {{ form.fileName }}
        </a>
      </h6>
      <div>
        Upload date: {{ form.formDate | date: 'MM/dd/yyyy' }} |
        {{ form.formDate | date: 'mediumTime' }} | File Type: PDF
      </div>
      <div>&nbsp;</div>
    </div>
    <div
      *ngIf="
        (enrollForms && enrollForms.length > itemsPerPage) ||
        itemsPerPage > 5
      "
      style="margin-top: 1rem"
      class="d-flex align-items-center"
    >
      <app-pagination
        (pageSet)="pageSet($event)"
        [totalItems]="enrollForms.length"
        [itemsPerPage]="itemsPerPage"
        [currentPage]="page"
      >
      </app-pagination>
      <div
        class="form-group d-flex align-items-center"
        style="margin-left: 1.5rem"
      >
        <label
          style="
            font-weight: normal;
            font-size: 0.75rem;
            margin-bottom: 0;
            margin-right: 0.75rem;
          "
          for="itemsPerPage"
        >Items per page</label
        >
        <select
          style="padding: 1rem"
          class="form-control"
          id="itemsPerPage"
          (change)="setItemsPerPage($event)"
          style="
            width: 45px;
            height: 30px;
            padding: 0;
            border-radius: 3px;
            border-color: #dee2e6;
            font-size: 0.75rem;
          "
        >
          <option [selected]="itemsPerPage === 5" value="5">5</option>
          <option [selected]="itemsPerPage === 10" value="10">10</option>
          <option [selected]="itemsPerPage === 25" value="25">25</option>
        </select>
      </div>
    </div>
  </div>
</div>
